import React, { useLayoutEffect, useRef, useState } from "react";

import TemplateHTMLPreview from "../BeefreeTemplates/TemplateHTMLPreview";

const desktopContainerStyle = {
  boxSizing: "border-box",
  height: "60vh",
  overflow: "hidden",
  padding: "5px",
};

const desktopFrameStyle = {
  height: "100%",
  overflow: "hidden",
};

const mobileContainerStyle = {
  background: "var(--sl-bg-tertiary)",
  display: "grid",
  height: "60vh",
  padding: "10px",
  placeItems: "center",
};

const mobileFrameStyle = {
  background: "#FFFFFF",
  height: "100%",
  maxHeight: "60vh",
  maxWidth: "100%",
  overflow: "auto",
  width: "320px",
};

const iframeStyle = {
  background: "#FFFFFF",
  border: "none",
  height: "100%",
  overflow: "scroll",
  width: "100%",
};

const EmailPreviewViewer = ({ htmlContent, frameWidth, viewer }) => {
  const frameRef = useRef(null);
  const [available, setAvailable] = useState(0);
  const desktop = viewer === "desktop";

  useLayoutEffect(() => {
    const node = frameRef.current;
    const measure = () => setAvailable(node.clientWidth);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [viewer]);

  const space = available || frameWidth;
  const width = Math.max(frameWidth, space);
  const scale = space / width;

  return (
    <div style={desktop ? desktopContainerStyle : mobileContainerStyle}>
      <div ref={frameRef} style={desktop ? desktopFrameStyle : mobileFrameStyle}>
        <TemplateHTMLPreview
          htmlContent={htmlContent}
          style={desktop ? {
            ...iframeStyle,
            height: `${100 / scale}%`,
            transform: `scale(${scale})`,
            transformOrigin: "0 0",
            width,
          } : iframeStyle}
        />
      </div>
    </div>
  );
};

export default EmailPreviewViewer;
